<template>
  <div class="CreatvallStyle">
    <div class="title" ref="creatInnerHtmlTitle">创建直播</div>
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="80px" class="CreatVhallForm">
      <el-form-item label="直播名称" prop="subject">
        <el-input v-model="ruleForm.subject"></el-input>
      </el-form-item>
      <el-form-item label="直播时间" required>
        <el-col :span="11">
          <el-form-item prop="date1">
            <el-date-picker v-model="ruleForm.date1" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
              placeholder="选择日期" :picker-options="pickerOptions0">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item prop="date2">
            <el-time-picker v-model="ruleForm.date2" format="HH:mm" value-format="HH:mm" placeholder="任意时间">
            </el-time-picker>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label="直播简介">
        <el-input type="textarea" v-model="ruleForm.introduction"></el-input>
      </el-form-item>
      <el-form-item label="直播海报">
        <el-upload class="avatar-uploader" action="string" :show-file-list="false" :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload" :http-request="UploadImage">
          <img v-if="imageUrl" :src="imageUrl" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <!-- <el-form-item label="直播Url" v-if="LiveUrl">
        <el-input v-model="ruleForm.Url"></el-input>
      </el-form-item> -->
      <el-form-item v-if="liveStatusStr" label="直播状态">
        <div>
            {{liveStatusStr}}
            <div style="float: right; display:none;" v-if="showToPreBtn">
                <el-button @click="onSetToPreStatus" type="success">恢复成预告</el-button>
            </div>
        </div>
      </el-form-item>
      <el-form-item label="主持人口令" v-if="$route.params.item && $route.params.item.webinarId">
        <div class="token_content">
            <p>直播ID：{{$route.params.item ? $route.params.item.webinarId : ''}}</p>
            <p>主持人口令：{{hostToken}}</p>
            <div>
                加入链接：
                <el-link class="link" target="_blank" type="warning" :href="'http://e.vhall.com/mywebinar/host-login/' + $route.params.item.webinarId">{{'http://e.vhall.com/mywebinar/host-login/' + $route.params.item.webinarId}}</el-link>
            </div>
        </div>
      </el-form-item>
      <el-form-item v-if="$route.params.item && $route.params.item.webinarId">
        <el-button v-if="liveStatus === liveStatusTypes.ongoing" @click="onEndLive" type="danger">结束直播</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit" ref="creatInnerHtml">立即创建</el-button>
        <el-button>取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import { creatlive, netmettingupdate, endLive, queryLiveStatus, setLiveToPreState, getHostToken } from '@/api/VhallLive'
  import { actionuploadImg } from '@/api/img'
  import { showConfirm, toastSuccess } from '../../common/utils/ui'
  export default {
    name: 'CreatVhall',
    data() {
      return {
        pickerOptions0: {
          disabledDate(time) {
            // 过去的日期不可被选择 3600 * 1000 * 24 = 8.64e7[86400000]
            return time.getTime() < Date.now() - 8.64e7
          }
        },
        rules: {
          subject: [
            { required: true, message: '请输入活动名称', trigger: 'blur' },
          ],
          date1: [
            { required: true, message: '请选择日期', trigger: 'change' }
          ],
          date2: [
            { required: true, message: '请选择时间', trigger: 'change' }
          ],
        },
        ruleForm: {
          subject: '',
          date1: '',
          date2: '',
          player: 2,
          Url: '',
          introduction: ''
        },
        // 直播
        imageUrl: '',
        LiveUrl: false,
        liveStatusStr: '', // 直播状态
        showToPreBtnBtn: false, // 展示恢复成预告的按钮
        hostToken: '', // 主持人口令
        liveStatus: '', // 直播状态
        liveStatusTypes: {
            ongoing: 1, // 直播中
            end: 3, // 结束状态
            playback: 5, // 回放
            notice: 2 // 预告
        }
      }
    },
    creat () {
        
    },
    watch: {},
    mounted() {
      // 修改直播
    //   console.log('----')
    //   console.log(this.$route.params.item)
      if (this.$route.params.item) {
        // console.log(this.$route.params.item)
        this.$refs.creatInnerHtmlTitle.innerHTML = '编辑'
        this.$refs.creatInnerHtml.$el.innerText = '保存'
        this.ruleForm.subject = this.$route.params.item.subject
        this.imageUrl = this.$route.params.item.imgUrl
        this.ruleForm.Url = this.$route.params.item.playUrl
        this.ruleForm.introduction = this.$route.params.item.introduction
        if (this.$route.params.item.startTime) {
          var dateSplit = this.$route.params.item.startTime.split(' ')
          this.ruleForm.date1 = dateSplit[0]
          this.ruleForm.date2 = dateSplit[1]
        }
        this.LiveUrl = true

            // 查询直播状态
            this.queryLiveState()
            this.queryHostToken()
      }
    },
    methods: {
      // 图片上传
      handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw)
      },
      // 文件提交
      UploadImage(param) {
        // console.log(param.file)
        const formData = new FormData()
        formData.append('file', param.file)
        // console.log(formData.has("file"))
        actionuploadImg(formData).then(response => {
        //   console.log(response)
          this.imageUrl = response
        })
      },
      beforeAvatarUpload(file) {
        // const isJPG = file.type === 'image/jpeg'
        const isLt2M = file.size / 1024 / 1024 < 2
        // if (!isJPG) {
        //   this.$message.error('上传头像图片只能是 JPG 格式!')
        // }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!')
        }
        // return isJPG && isLt2M;
        return isLt2M;
      },
      onSubmit() {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            if (this.$route.params.item) {
              this.apiSendUpdate()
            } else {
              this.apiSend()
            }
          } else {
            console.log('error submit!!')
            return false;
          }
        })
      },
      // 添加页面
      apiSend() {
        var obj = {
          subject: this.ruleForm.subject,
          startTime: this.ruleForm.date1 + ' ' + this.ruleForm.date2,
          player: this.ruleForm.player,
          imgUrl: this.imageUrl,
          introduction: this.ruleForm.introduction
        }
        creatlive(obj).then(response => {
        //   console.log(response.data)
          if (response.data) {
            this.$message({
              message: '页面添加成功',
              type: 'success'
            })
            this.$router.push({ name: 'Livelist' })
          }
        })
      },
      // 修改页面
      apiSendUpdate() {
        var obj = {
          webinarId: this.$route.params.item.webinarId,
          subject: this.ruleForm.subject,
          startTime: this.ruleForm.date1 + ' ' + this.ruleForm.date2,
          imgUrl: this.imageUrl,
          introduction: this.ruleForm.introduction
        }
        // console.log(obj)
        netmettingupdate(obj).then(response => {
        //   console.log(response)
          this.$message({
            message: '修改页面成功',
            type: 'success'
          })
          this.$router.push({ name: 'Livelist' })
        })
      },
        onEndLive () {
            showConfirm('确定要结束直播吗', '结束直播确认').then(() => {
                const liveId = this.$route.params.item.webinarId
                endLive(liveId).then(ret => {
                    if (ret.code === '200') {
                        toastSuccess('直播结束成功')
                    }
                })
            })
        },
        // 查询直播状态
        queryLiveState () {
            const liveId = this.$route.params.item.webinarId
            if (!liveId) {
                return
            }
            queryLiveStatus(liveId).then((ret = {}) => {
                const data = ret.data
                let statusStr = ''
                // 文档 ：https://www.vhall.com/saas/doc/36.html
                switch (data) {
                    case 1: // 直播进行中, 参加者可以进入观看直播
                        statusStr = '直播中'
                        break

                    case this.liveStatusTypes.notice: // 预约中 , 直播预约中,尚未开始
                        statusStr = '预告'
                        
                        break

                    case this.liveStatusTypes.end: // 直播已结束
                        statusStr = '结束'
                        this.showToPreBtn = true
                        break

                    case 4: // 当前为点播
                        // statusStr = '点播'
                        break
                    
                    case this.liveStatusTypes.playback: // 回放
                        statusStr = '回放'
                        this.showToPreBtn = true
                        break
                    
                    default:
                        statusStr = ''
                }
                const liveId = this.$route.params.item.webinarId
                if (!liveId) {
                    return
                }
                this.liveStatusStr = statusStr
                this.liveStatus = data
            })
        },
        // 设置为预告状态
        onSetToPreStatus () {
            setLiveToPreState()
        },

        queryHostToken () {
            const liveId = this.$route.params.item.webinarId
            if (!liveId) {
                return
            }
            getHostToken(liveId).then((ret = {}) => {
                const { data } = ret
                if (data) {
                    this.hostToken = data.host_password
                }
                
            })
        }
    }
  }
</script>

<style scoped lang="scss">
  .CreatvallStyle {}

  .title {
    font-size: 20px;
    padding: 15px 0px 0px 15px;
  }

  .CreatVhallForm {
    width: 500px;
    margin-top: 50px;
  }

  /* 直播 */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 300px;
    height: 178px;
    line-height: 178px;
    text-align: center;
    border: 1px dotted;
  }

  .avatar {
    width: 300px;
    height: 178px;
    display: block;
  }
  .token_content {
        font-size: 12px;
        color: #999;
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        padding: 10px;
        line-height: 20px;
        .link {
            font-size: 12px;
        }
  }
</style>



// WEBPACK FOOTER //
// src/views/Live-Platform/creat-vhall.vue